import Row from 'blocks/Row';
import { RecieptCardProps } from './recipt.interface';
import * as S from './reciptCard.styles';

const RecieptCard = ({ rows, className }: RecieptCardProps) => (
  <S.RecieptCard className={className}>
    {rows.map((item) => (
      <S.RecieptCardItm as={Row} align="center" justify="space-between" key={item.id}>
        <S.RecieptCardItmKey>{item.name}</S.RecieptCardItmKey>
        <S.RecieptCardItmValue>{item.content}</S.RecieptCardItmValue>
      </S.RecieptCardItm>
    ))}
  </S.RecieptCard>
);

RecieptCard.defaultProps = {
  className: '',
};

export default RecieptCard;
